import useMedia from '@/hooks/useMedia';
const useBreakpoint = () => {
  const isXs = useMedia('(max-width: 575px)');
  const isSm = useMedia('(min-width: 576px) and (max-width: 767px)');
  return { isXs, isSm };
};

export default useBreakpoint;
